import { Button, Card, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, InputLabel, makeStyles, TextField } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { getAccountDocument, getIndividualDocument, postAccountDocument } from "../../../actions/driverAppApprovalActions";
import { driverServerInstance } from "../../../axios/instances";
import { driverDocUploadListCA, driverDocUploadListUS } from "../../../constants/general";
import { showAlertSnackbar } from "../../../reducers/uiSlice";
import { DataURIToBlob } from "../../../utilities/common";
import TimeoutButton from "../../Common/TimeoutButton";
import DocFile from "./Signature";
import update from 'immutability-helper';
import { useToken } from "../../../utilities/hooks";

const useStyles = makeStyles((theme) => ({
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    signatureBackground: {
        width: '320px !important',
        height: '200px !important',
        borderRadius: 4,
        borderColor: '#636463',
        borderWidth: 2,
        borderStyle: 'dashed',
        backgroundColor: '#262626'
    },
    signatureGroup: {
        marginTop: 18,
        marginBottom: 60,
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%',
        gap: '41px 61px',
        justifyContent: 'center'
    },
    title: {
        fontSize: 16,
        fontWeight: 'bold',
        marginBottom: 10
    },
    signatureTitle: {
        fontSize: 14,
        fontWeight: 'normal',
        color: '#a3a4a0',
        marginBottom: 10
    }
}))

function AddReplaceDocument(props) {
    const {t} = useTranslation('driverApproval');
    const classes = useStyles();
    const dispatch = useDispatch();
    const tokenContents = useToken();
    const userUS = tokenContents.userUS;

    const uploadList = userUS ? driverDocUploadListUS : driverDocUploadListCA;

    const [openModal, setOpenModal] = useState(false);
    const [documentUploadList, setDocumentUploadList] = useState(uploadList);

    function handleDocument(type, index, docFile) {
        let copy = JSON.parse(JSON.stringify(documentUploadList));
        if(type === 'upload') {
            copy[index].preview = docFile.preview;
            copy[index].document = docFile; 
        } else if(type === 'delete') {
            copy[index].preview = undefined;
            copy[index].document = undefined;
            copy[index].access_url = undefined;
        }
        props.handleUploadDocument(copy);
    }

    useEffect(() => {
        setOpenModal(props.open);
    }, [props.open])
    useEffect(() => {
        if(props.documentUploadList) {
            setDocumentUploadList(props.documentUploadList)
        }
    }, [props.documentUploadList])

    return (
        <Dialog
            open={openModal}
            maxWidth='md'
            fullWidth
        >
            <DialogTitle style={{borderBottom: '2px solid #515151'}}>
                    {t('upload_photos')}
                    <IconButton size="small" className={classes.closeButton} onClick={props.handleClose}>
                        <Close />
                    </IconButton>              
            </DialogTitle>
            <DialogContent>
                <div
                    className={classes.signatureGroup}
                >
                {
                    documentUploadList &&
                    documentUploadList.length > 0 &&
                    documentUploadList.map((document, index) => (
                        document.type === 'placeholder' ?
                            <div style={{ width: 320 }}></div>
                            :
                            <div
                                style={
                                    {
                                        display: 'block',
                                        width: 320
                                    }
                                }
                            >
                            <div
                                className={classes.title}
                                style={document.position!==0?{color: '#8a8b8a'}:{color: '#424242'}}
                            >
                                {t(`${document.type}`)}
                            </div>
                            <div className={classes.signatureTitle}>
                                {document.name}
                            </div>
                            <div className={classes.signatureBackground}>
                                <DocFile document={document} index={index} handleDocument={handleDocument} documentUploadList={documentUploadList}  accountId={props.accountId} />
                            </div> 
                        </div>   
                    ))
                }
                </div>
            </DialogContent>
        </Dialog>
    )
}

export default AddReplaceDocument;